// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Image = function Image(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 3.75c0-1.379 1.121-2.5 2.5-2.5h15c1.379 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5zm12.648 4.16a.935.935 0 0 0-1.546 0l-3.399 4.985-1.035-1.293a.935.935 0 0 0-1.46 0l-2.501 3.125a.935.935 0 0 0 .73 1.523h13.126a.93.93 0 0 0 .828-.5.94.94 0 0 0-.055-.965zM4.375 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75"
  }));
};
